import "client-only";

import type { Session } from "next-auth";
import { getSession } from "next-auth/react";

let inFlight: Promise<Session | null> | null = null;

/** GET `/api/auth/session` — honors bump cookie and JWT authz TTL on the server. */
export async function refreshSessionAuthz(): Promise<Session | null> {
  if (!inFlight) {
    inFlight = getSession().finally(() => {
      inFlight = null;
    });
  }
  return inFlight;
}

/** Call after a server action that sets `waas-authz-bump` so the mutator's JWT authz refreshes. */
export async function refreshSessionAuthzAfterMutation(): Promise<void> {
  await refreshSessionAuthz();
}
